module.exports = __webpack_public_path__ + "static/media/tacoma_county.55325d73.jpg";